import { memo, useCallback, useMemo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { Picker } from "@design-system/Picker/Picker.lib";
import {
    CounterpartyCombobox,
    CounterpartyComboboxValue,
} from "@components/transactions/TransactionSplitV2/CounterpartyCombobox";
import { useSimilarTransactionsNewValue } from "./SimilarTransactionsNewValueContext";

export const CounterpartyNewValueCell: React.FC<{
    transactionId: number;
    currentValue: string | null;
}> = memo(({ transactionId, currentValue }) => {
    const { setNewValue, newValueLabelsMap, displayedChangedEntityName } =
        useSimilarTransactionsNewValue();

    const displayName =
        newValueLabelsMap[transactionId] ?? displayedChangedEntityName ?? "";
    const selectedCounterparty = currentValue
        ? { id: currentValue, name: displayName }
        : undefined;

    const handleChange = useCallback(
        (counterparty?: CounterpartyComboboxValue) => {
            if (!counterparty) {
                return;
            }
            setNewValue(transactionId, counterparty.id, counterparty.name);
        },
        [transactionId, setNewValue],
    );

    const trigger = useMemo(
        () => (
            <Picker.CellContent
                value={currentValue ? displayName : undefined}
            />
        ),
        [currentValue, displayName],
    );

    return (
        <ViewTableCell captureClicks>
            <CounterpartyCombobox
                selectedCounterparty={selectedCounterparty}
                onChange={handleChange}
                forTransactionEditing
                hideArrow
                trigger={trigger}
            />
        </ViewTableCell>
    );
});
CounterpartyNewValueCell.displayName = "CounterpartyNewValueCell";
